import React from 'react';
import { connect } from 'react-redux';
import { getCatalogMenuList } from '../redux/actions/menuActions';
import { getSearchItemsBox } from '../redux/actions/productActions';

// import axios from 'axios';
import SearchBox from './search/SearchBox';
import Filters from './Filters';
import Brand from './sidebarCategory/Brand';
import CategorySidebarTypes from './sidebarCategory/CategorySidebarTypes';
import {
    Route
} from 'react-router-dom';

import CategorySidebarItem from '../components/sidebarCategory/CategorySidebarItem';
import SearchBoxModal from '../components/search/SearchBoxModal';

import SearchBrand from '../components/search/SearchBrand';
import SearchCategories from '../components/search/SearchCategories';

import CurrencyMenuItem from './other/CurrencyMenuItem';
import VatMenuItem from './other/VatMenuItem';
import { globalStatistic } from '../redux/actions/otherActions';
import { withTranslation } from 'react-i18next';
import SecureLS from 'secure-ls';
import DarkModeToggle from './DarkModeToggle';

class CategorySidebar extends React.Component {


    constructor(props) {
        super(props);
        let ls = new SecureLS({ encodingType: 'aes' });
        this.isLoggedIn = ls.get('userInfo');

        // Get initial dark mode state from localStorage
        const savedDarkMode = localStorage.getItem('isDarkMode');
        const isDarkMode = savedDarkMode === 'true';

        this.state = {
            menu: [],
            sidebar: 'filter',
            searchBox: 0,
            searchListBox: [],
            searchText: '',
            isDarkMode,
        };
    };

    componentDidMount() {
        this.props.getCatalogMenuList();

        // // Check if dark mode is set in localStorage
        // const savedDarkMode = localStorage.getItem('isDarkMode');
        // if (savedDarkMode === null || savedDarkMode === undefined) {
        //     // If no setting exists, default to light mode and save it
        //     localStorage.setItem('isDarkMode', 'false');
        //     this.applyDarkMode(false);
        // } else {
        //     // Apply the saved dark mode setting
        //     const isDarkMode = savedDarkMode === 'true';
        //     this.setState({ isDarkMode });
        //     this.applyDarkMode(isDarkMode);
        // }
    }

    handleDarkModeToggle = (newMode) => {
        this.setState({ isDarkMode: newMode });
    };

    // applyDarkMode = (isDarkMode) => {
    //     const root = document.documentElement;

    //     if (isDarkMode) {
    //         // Dark mode variables
    //         root.style.setProperty('--background-color', '#181D27');
    //         root.style.setProperty('--text-color', '#FAFAFA');
    //         root.style.setProperty('--title-color', '#ffffff');
    //         root.style.setProperty('--theme-full-black', '#ffffff');
    //         root.style.setProperty('--theme-black', '#ffffff');
    //         root.style.setProperty('--theme-white', '#181D27');

    //         // Inverted gray colors for dark mode
    //         root.style.setProperty('--gray-50', '#0A0D12');
    //         root.style.setProperty('--gray-100', '#181D27');
    //         root.style.setProperty('--gray-200', '#252B37');
    //         root.style.setProperty('--gray-300', '#414651');
    //         root.style.setProperty('--gray-400', '#535862');
    //         root.style.setProperty('--gray-500', '#717680');
    //         root.style.setProperty('--gray-600', '#A4A7AE');
    //         root.style.setProperty('--gray-700', '#D5D7DA');
    //         root.style.setProperty('--gray-800', '#E9EAEB');
    //         root.style.setProperty('--gray-900', '#F5F5F5');
    //         root.style.setProperty('--gray-950', '#FAFAFA');
    //         root.style.setProperty('--gray-975', '#FDFDFD');
    //     } else {
    //         // Light mode variables
    //         root.style.setProperty('--background-color', '#ffffff');
    //         root.style.setProperty('--text-color', '#535862');
    //         root.style.setProperty('--title-color', '#181D27');
    //         root.style.setProperty('--theme-full-black', '#000000');
    //         root.style.setProperty('--theme-black', '#111111');
    //         root.style.setProperty('--theme-white', '#ffffff');

    //         // Original gray colors for light mode
    //         root.style.setProperty('--gray-50', '#FDFDFD');
    //         root.style.setProperty('--gray-100', '#FAFAFA');
    //         root.style.setProperty('--gray-200', '#F5F5F5');
    //         root.style.setProperty('--gray-300', '#E9EAEB');
    //         root.style.setProperty('--gray-400', '#D5D7DA');
    //         root.style.setProperty('--gray-500', '#A4A7AE');
    //         root.style.setProperty('--gray-600', '#717680');
    //         root.style.setProperty('--gray-700', '#535862');
    //         root.style.setProperty('--gray-800', '#414651');
    //         root.style.setProperty('--gray-900', '#252B37');
    //         root.style.setProperty('--gray-950', '#181D27');
    //         root.style.setProperty('--gray-975', '#0A0D12');
    //     }
    // };

    selectedSidebarCategoryType = (item) => {
        this.setState({
            sidebar: item,
        });
    };
    gatherStat = (type, value) => {
        const { globalStatistic } = this.props;
        globalStatistic(type, value);
    }

    callbackSearchBox = (searchBoxLength, valItem) => {
        if (searchBoxLength > 0) {
            this.setState({
                searchBox: 1,
            });
        } else {
            this.setState({
                searchBox: 0,
            });
        };

        if (searchBoxLength > 3) {
            this.props.getSearchItemsBox(valItem, '');
            this.gatherStat(valItem, 'SEARCH')
        } else {

            this.setState({
                searchBox: 0,
            });
            this.props.getSearchItemsBox(valItem, 'clear');
        };

        this.setState({
            searchText: valItem
        })

    };
    callbackSerachFunction = () => {
        this.setState({
            searchBox: 0,
        });
    };

    callbackSearchBoxSetModal = () => {
        // todo
    };

    renderList() {
        const { location } = this.props;
        const { getB2bSettings } = this.props;
        const anCategoryForHide = getB2bSettings.items.anCategoryForHide || '';
        let hiddenCategoryIds = [];
        if (anCategoryForHide.trim() !== '') {
            //tumacim string ko ceo broj i zto pisem  .map(id => parseInt(id, 10));
            hiddenCategoryIds = anCategoryForHide.split(',').map(id => parseInt(id, 10));
        }
        let catalogItemsList = this.props.catalogItems;

        if (hiddenCategoryIds.length > 0) {
            catalogItemsList = catalogItemsList.filter(item => !hiddenCategoryIds.includes(item._id));
        }

        return catalogItemsList.map((item, key) => (
            <CategorySidebarItem key={key} item={item} />
        ));
    }
    searchBoxModalClosedFunciot = () => {
        this.setState({
            searchBox: 0,
            searchText: ''
        });
    }

    setShowSearchBoxFunction = () => { };

    setSearchNameFunctionSet = (valItem) => {
        this.setState({
            searchText: valItem
        })
    }


    render() {
        const { t } = this.props;
        return (

            <>
                <div className="category-content-sidebar d-none d-lg-block">
                    <div className="sidebar-fixed-menu">
                        <div className="navbar-category ">
                            <Route render={({ history }) => <SearchBox
                                setSearchNameFunction={this.setSearchNameFunctionSet}
                                setShowSearchBox={this.setShowSearchBoxFunction}
                                closeSearchModalFunction={this.callbackSerachFunction}
                                searchFunctionClick={this.callbackSearchBoxSetModal}
                                searchBoxFunction={this.callbackSearchBox}
                                history={history}
                                searchText={this.state.searchText}
                            ></SearchBox>}></Route>
                            {this.isLoggedIn && (
                                <>
                                    <div className="value-radio-items"
                                        style={{
                                            display: this.props.currencyItems.length > 1 ? 'flex' : 'block'
                                        }}>
                                        {this.props.currencyItems.length > 1 && (
                                            <div className="category-sidebar-value-item">
                                                <div className="category-sidebar-item-radio-name">
                                                    {t('components:valuta')}
                                                </div>
                                                <div className="category-sidebar-item-radio-buttons">
                                                    {this.props.currencyItems.map((item, key) => (
                                                        <CurrencyMenuItem
                                                            key={key}
                                                            item={item}
                                                            isPriceInEur={this.props.activeCurrency._id}
                                                            productItem={this.props.productItem}
                                                            activeVat={this.props.activeVat}
                                                            inputName={'1'}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        <div className="category-sidebar-value-price">
                                            <div className="category-sidebar-item-radio-name">
                                                {t('components:ceneIpdv')}
                                            </div>
                                            <div className="category-sidebar-item-radio-buttons">
                                                <VatMenuItem
                                                    productItem={this.props.productItem}
                                                    activeVat={this.props.activeVat}
                                                />
                                                {/* <VatMenuItem productItem={this.props.productItem} vatInputId={'test2'} radioLabel={'NE'} defaultVal={"0"} /> */}
                                            </div>
                                        </div>
                                    </div>                            
                                    {this.state.isDarkMode ? (
                                        this.isLoggedIn && (
                                        <>
                                            <DarkModeToggle
                                                t={t}
                                                initialMode={this.state.isDarkMode} // Pass initial state from localStorage
                                                onToggle={this.handleDarkModeToggle}
                                            />
                                        </>
                                    )) : (
                                        ''
                                    )}
                                        {/* {this.state.isDarkMode ? (
                                            <div className="dark-mode-toggle">
                                                {this.state.isDarkMode ? (
                                                    <p>{t('components:rezimTamni')} &nbsp;</p>
                                                ) : (
                                                    <p>{t('components:rezimSvetli')} &nbsp;</p>
                                                )}
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.isDarkMode} // Use the state variable
                                                        onClick={this.toggleDarkMode}
                                                    />
                                                    <div className="slider round">
                                                    {this.state.isDarkMode ? (
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-moon-icon lucide-moon"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>
                                                    ) : (
                                                        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sun-icon lucide-sun"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>
                                                    )}
                                                    </div>
                                                </label>
                                            </div>
                                        ) : (
                                            ''
                                        )} */}
                                    
                                </>
                            )}


                            <Route render={({ history }) => <CategorySidebarTypes setSidebarCategory={this.selectedSidebarCategoryType} history={history} ></CategorySidebarTypes>}></Route>
                            {
                                this.state.sidebar === 'category' ? (
                                    <div className="content-category-boxes">
                                        <ul className="menu-items">
                                            {this.renderList()}
                                        </ul>
                                    </div>
                                ) : this.state.sidebar === 'filter' ? (
                                    <div className="content-category-boxes">
                                        <Filters />
                                    </div>
                                ) : this.state.sidebar === 'brand' ? (
                                    <div className="content-category-boxes">
                                        <Brand />
                                    </div>
                                ) : (
                                    <div className="content-category-boxes">
                                        <div className="search-brands-block-content">
                                            <h3>Brendovi</h3>
                                            <div className="line-h5-filter"></div>
                                            <SearchBrand />
                                        </div>
                                        <div className="search-categories-block-content">
                                            <h3>Kategorije</h3>
                                            <div className="line-h5-filter"></div>
                                            <SearchCategories />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <SearchBoxModal
                    searchText={this.state.searchText}
                    items={this.props.getSearchItemsBoxList}
                    searchBoxModalFunction={this.callbackSerachFunction}
                    searchBoxModal={this.state.searchBox}
                    searchBoxModalClosed={this.searchBoxModalClosedFunciot}

                />
            </>
        );
    };

};

const mapStateToProps = (state) => {
    return {
        catalogItems: state.getCatalogMenuList,
        getSearchItemsBoxList: state.getSearchItemsBox,
        currencyItems: state.getCurrencyItems,
        activeCurrency: state.activeCurrency,
        activeVat: state.activeVat.item,
        productItem: state.productDetail.items[0],
    };
};

export default withTranslation('components')(connect(
    mapStateToProps,
    {
        getCatalogMenuList,
        getSearchItemsBox,
        globalStatistic
    }
)(CategorySidebar));